<template>
  <footer class="py-5">
    <b-container class="justify-content-center text-center">
      <hr />
      <div class="px-3">
        &copy; 2020 codevalop.com
      </div>
      <div>
        <font-awesome-icon icon="envelope" class="mr-1" />
        <a href="mailto:codevalop@gmail.com">codevalop@gmail.com</a>
      </div>
    </b-container>
  </footer>
</template>

<script>
  export default {
    name: "Footer",
  };
</script>
